import { render, staticRenderFns } from "./bidding-list.vue?vue&type=template&id=095c6604&scoped=true&"
import script from "./bidding-list.vue?vue&type=script&lang=js&"
export * from "./bidding-list.vue?vue&type=script&lang=js&"
import style0 from "./bidding-list.vue?vue&type=style&index=0&id=095c6604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095c6604",
  null
  
)

export default component.exports